import styled from "styled-components";

export const PreviewSubmitSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 16px;
`;

export const TossSectionTitle = styled.div`
  display: flex;
  width: 100%;
  font-size: 28px;
  color: ${({ theme }) => theme.colors.BLACK};
  padding: 50px 0 0 10px;
  font-weight: bold;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 6px;

  @media (max-width: 768px) {
    width: calc(100% - 20px);
    margin: 6px 10px;
  }
`;

export const PreviewSubmitTossSection = styled.div`
  display: flex;
  flex-direction: column;
  border: 0px solid ${({ theme }) => theme.colors.GREY_HEAVY};
  border-radius: 12px;
  box-sizing: border-box;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  background-color: white;
  margin-left: 10px;
  margin-top: 20px;
  padding-bottom: 20px;

  @media (max-width: 768px) {
    width: calc(100% - 20px);
    margin: 6px 10px;
  }
`;

export const ClearButton = styled.button`
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.BLUE_HEAVY};
  border-radius: 4px;
  padding: 6px;
  :hover {
    background-color: ${({ theme }) => theme.colors.BLUE_LIGHT};
  }
`;

export const PayButton = styled.button<{ isDisabled: boolean }>`
  padding: 16px 40px 14px 40px;
  font-size: 16px;
  background-color: ${({ theme }) =>
    (props) =>
      props.isDisabled ? theme.colors.GREY_HEAVY : theme.colors.BLACK};
  color: ${({ theme }) => theme.colors.WHITE};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 auto;
`;

export const SubmitButton = styled.button<{ isDisabled: boolean }>`
  padding: 16px 40px 14px 40px;
  font-size: 16px;
  background-color: ${({ theme }) =>
    (props) =>
      props.isDisabled ? theme.colors.GREY_HEAVY : theme.colors.BLUE_HEAVY};
  color: ${({ theme }) => theme.colors.WHITE};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 auto;
`;
